module.exports = __webpack_public_path__ + "static/media/Finder.c9831f64.svg";